import React, { useContext, useEffect, useState } from 'react';
import OfferBanner from '../OfferBanner';
import { AlertWrapper, TabContentWrapper } from '../UI/styledConstants';
import { getAepsBankList } from '../../utils/api';
import { overLayers, isEmpty, getLocation } from '../../utils/common';
import Loader from '../UI/Loader/Loader';
import AepsReceipt from './AepsReceipt';
import SelectDeviceType from './SelectDeviceType';
import AepsOtpScreen from './AepsOtpScreen';
import CaptureFingerprint from './CaptureFingerprint';
import TransactionScreen from './TransactionScreen';
import { DiosmCapture, diosmMerchantDetail, diosmVerifyOtp, sendOtp } from './diosm';
import { GlobleContaxt } from '../../Context/GlobleContaxt';

const initialControls = {
	transactionType: '',
	aadharNumber: '',
	amount: '',
	bank: '',
	mobileNumber: '',
};

export default function AEPS({ className = '' }) {
	const [bankList, setBankList] = useState(null);
	const [transactionType, setTransactionType] = useState('');
	const [filterBankList, setFilterBankList] = useState(null);
	const [bankDataResp, setBankDataResp] = useState({});
	const [dropDown, setDropdown] = useState(false);
	const [searchKey, setSearchKey] = useState('');
	const [message, setMessage] = useState({});
	const [seconds, setSeconds] = useState(30);
	const [controls, setControls] = useState({ ...initialControls });
	const [overLayer, setOverLayer] = useState(false);
	const [loading, setLoading] = useState(false);
	const [aepsStatus, setAepsStatus] = useState('yes');
	const [otp, setOtp] = useState(['', '', '', '', '', '']);
	const [payload, setPayload] = useState({});
	const [fingerprintLoader, setFingerprintLoader] = useState(false);
	const [deviceType, setDeviceType] = useState('Mantra');

	const number = /^[0-9]+$/;
	const nameReg = /^[A-Za-z\s]+$/i;

	const dType = localStorage.getItem('deviceType');
	const { setRefresh,refresh,geolocation,setGeolocation,setAlert} = useContext(GlobleContaxt);

	useEffect(() => {
		if (dType) {
			setDeviceType(dType);
		}
	}, [dType]);

	const onChangeHandler = (e) => {
		


		if (e.target.name === 'amount' || e.target.name === 'aadharNumber' || e.target.name === 'mobileNumber') {
			if (!number.test(e.target.value) && e.target.value) {
				return false;
			}
		}

		setControls({
			...controls,
			[e.target.name]: e.target.value,
		});

		if (e.target.name === 'bank') {
			setDropdown(false);
			setSearchKey(e.target?.nextElementSibling?.innerHTML);
		}
	};

	useEffect(() =>{

		function checkValues(obj) {
			let check = true;
			for (const key in obj) {
				if (obj.hasOwnProperty(key)) {
					const value = obj[key];
				
					if(!isEmpty(value)){
						check = false
					}
					
				}
			}
			return check;
		}

	 if(checkValues(controls)){
		setSearchKey('');
	 }
       
	},[controls])

	const onSubmitHandler = () => {
		if (controls.mobileNumber === '' || controls.mobileNumber === '' || controls.transactionType === '' || controls.bank === '') {
			setMessage({ type: 'error', msg: 'All field are required', place: 'form' });

			return;
		} else if (controls.mobileNumber.length !== 10) {
			setMessage({ type: 'error', msg: 'Enter 10 digit mobile number', place: 'form' });

			return;
		} else if (controls.aadharNumber.length !== 12) {
			setMessage({ type: 'error', msg: 'Enter 12 digit aadhar number', place: 'form' });

			return;
		} else if (controls.transactionType === 'Withdrawal' && controls.amount < 1) {
			setMessage({ type: 'error', msg: 'Enter Amount', place: 'form' });

			return;
		}

		let latitude = '17.3644687';
		let longitude = '78.35583746';

		if (!isEmpty(geolocation?.latitude)) {
		   
		      latitude = (geolocation.latitude).toFixed(7);
		      longitude = (geolocation.longitude).toFixed(7);
		  }

		const body = {
			merchantId: '',
			agent_trid: '',
			adhaarNumber: controls.aadharNumber,
			bankIIN: controls.bank,
			amount: 0,
			mobileNumber: controls.mobileNumber,
			transactionType: controls.transactionType,
			latitude: latitude,
			longitude: longitude,
			pid_xml_base64e: 'string',
		};

		setTransactionType(controls.transactionType);
		if ((controls.transactionType === 'Withdrawal') || (controls.transactionType === 'AP')  ) {
			body.amount = controls.amount;
		} else {
			body.amount = 0;
		}
		setPayload(body);
		//checkStatus(body);
		if ((controls.transactionType === 'Withdrawal') || (controls.transactionType === 'AP') ) {
			setAepsStatus('verifyCustomerForTransaction');
		} else {
			setAepsStatus('verifyCustomer');
		}
	};

	useEffect(() => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({type:"error",msg:"Please login first to continue"})
			return;
		}
		getBankList();

		if(isEmpty(geolocation?.latitude)){
			setAlert({type:"warning",msg:"Please allow access to your location"})
			getLocation().then((position) =>{
                setGeolocation(position);
				diosmMerchantDetail(setLoading, setAepsStatus, setAlert,position);
			})

			return;
		}else{
			diosmMerchantDetail(setLoading, setAepsStatus, setAlert,geolocation)
		}
		
		
		
	}, []);

	const getBankList = () => {
		getAepsBankList().then((res) => {
			if (res?.data) {
				setBankList(res?.data);
			}
		});
	};

	function Capture(param, type) {
	
		DiosmCapture(param, type, deviceType, aepsStatus, setBankDataResp, overLayers, setOverLayer, setControls, setFingerprintLoader, controls, setAepsStatus, setAlert, setLoading);
	}

	const handleFilter = (event) => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({type:"error",msg:"Please login first to continue"})
			return;
		}

		if (bankList) {
			const keyword = event.target.value;
			if (!nameReg.test(keyword) && keyword) {
				return false;
			}

			setSearchKey(keyword.toUpperCase());

			const pattern = new RegExp('^' + keyword, 'i');
			const filtered = bankList.filter((item, index) => {
				return pattern.test(item.bankName);
			});

			if (keyword) {
				setFilterBankList(filtered.slice(0, 4));
			} else {
				setFilterBankList(null);
			}
		}
	};

	function closePop() {
		setOverLayer(false);
		setBankDataResp({});
		setLoading(false);
		overLayers(false);
		setSearchKey('');
		setMessage({});
		setControls({ ...initialControls });
		setAepsStatus('yes');
	}

	useEffect(() => {
		if (!isEmpty(message)) {
			const timer = setTimeout(() => {
				setMessage({});
			}, 5000);

			return () => clearTimeout(timer);
		}
	}, [message]);

	useEffect(() => {
		const timer = setInterval(() => {
			if (seconds === 0) {
				clearInterval(timer);
			} else {
				setSeconds(seconds - 1);
			}
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, [seconds]);

	//DISM otp verification
	const verifyOtp = () => {
		diosmVerifyOtp(setLoading, setAepsStatus, setAlert, otp, setOtp);
	};

	const resendOtp = () =>{
		sendOtp(setLoading,setAepsStatus,setAlert,geolocation);
		setSeconds(30);
	}

	useEffect(() =>{
		if(overLayer){
			setRefresh(!refresh);
		}

	},[overLayer])
	
	return (
		<TabContentWrapper className={`tab-content-wrapper ${className}`}>
			{!isEmpty(message) && message.place === 'globle' && (
				<AlertWrapper className={`${message.type} globle`}>
					<span className="close" onClick={() => setMessage({})}>
						×
					</span>
					{message.msg}
				</AlertWrapper>
			)}
			{((aepsStatus === 'selectDevice') || (aepsStatus === 'selectDeviceForVerify') || (aepsStatus === 'selectDeviceForTransaction') ) && (
				<SelectDeviceType setDeviceType={setDeviceType} deviceType={deviceType} setAepsStatus={setAepsStatus} aepsStatus={aepsStatus} />
			)}

			{aepsStatus === 'verifOtp' && <AepsOtpScreen setOtp={setOtp} otp={otp} seconds={seconds} message={message} setMessage={setMessage} verifyOtp={verifyOtp} resendOtp={resendOtp} />}

			{(aepsStatus === 'verifyFingerPrint' || aepsStatus === 'retailerLogin' || aepsStatus === 'verifyCustomer' || aepsStatus === 'verifyCustomerForTransaction') && (
				<CaptureFingerprint aepsStatus={aepsStatus} fingerprintLoader={fingerprintLoader} Capture={Capture} payload={payload} />
			)}

			{aepsStatus === 'yes' && (
				<TransactionScreen
					controls={controls}
					onChangeHandler={onChangeHandler}
					filterBankList={filterBankList}
					setDropdown={setDropdown}
					dropDown={dropDown}
					message={message}
					setMessage={setMessage}
					onSubmitHandler={onSubmitHandler}
					handleFilter={handleFilter}
					searchKey={searchKey}
					setAepsStatus={setAepsStatus}
				/>
			)}

			<div className="tab-content-right">
				{!loading && (
					<>
						<OfferBanner />
					</>
				)}
			</div>

			{loading && <Loader />}
			{overLayer && <AepsReceipt closePop={closePop} transactionType={transactionType} bankDataResp={bankDataResp} />}
		</TabContentWrapper>
	);
}
